<template>
  <div class="border-t border-t-grey-lighter">
    <div class="container">
      <ul class="flex gap-4">
        <li
          v-for="link in links"
          :key="link.id"
          :class="{ 'is-active': link.active, 'is-enabled': link.enabled }"
        >
          <a
            class="block py-4 font-bold text-black"
            :href="link.url"
            target="_blank"
            :class="{
              '!text-grey hover:!text-grey-darker': !link.enabled,
            }"
            >{{ link.label }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { notNullish } from '@vueuse/core'

const props = defineProps<{
  domainUrls: { id: string; href: string }[]
}>()

const { data: domains } = await useAsyncGraphqlQuery('getDomains', null, {
  transform: function (data) {
    return (data.data.entityQuery.items || [])
      .map((v) => {
        if (v && 'enum' in v) {
          return v
        }

        return null
      })
      .filter(notNullish)
  },
})

const { activeDomain } = useSiteContext()

const links = computed(() => {
  return (domains.value || []).map((domain) => {
    const domainUrl = props.domainUrls.find((v) => v.id === domain.enum)
    const fallback = `https://${domain.hostname}`

    return {
      id: domain.enum,
      label: domain.label || '',
      url: domainUrl?.href || fallback,
      active: domain.enum === activeDomain,
      enabled: !!domainUrl || domain.enum === activeDomain,
    }
  })
})
</script>
